import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';

@Module({ namespaced: true })
class Notifications extends VuexModule {

    public _show = false;
    public _message = "";
    public _color = "success";
    public _timeout = 3000;
    static dispatch: any;

    @Action
    showMessage(message: { text: string; color?: string; timeout?: number }): Promise<any> {
        this.context.commit('registerNewMessage', message);
        return Promise.resolve(true);
    }

    @Action
    showInfoMessage(message: string): Promise<any> {
        this.context.commit('registerNewMessage', { text: message, color: "success", timeout: 6000 });
        return Promise.resolve(true);
    }

    @Action
    showWarningMessage(message: string): Promise<any> {
        this.context.commit('registerNewMessage', { text: message, color: "amber accent-3", timeout: 6000 });
        return Promise.resolve(true);
    }

    @Action
    showErrorMessage(message: string): Promise<any> {
        this.context.commit('registerNewMessage', { text: message, color: "deep-orange darken-4", timeout: 6000 });
        return Promise.resolve(true);
    }

    @Mutation
    registerNewMessage(message: { text: string; color?: string; timeout?: number }) {
        this._message = message.text;
        if (!this._message || this._message == "") {
            this._show = false;
            this._color = "success";
            this._timeout = 3000;
        } else {
            this._show = true;
        }
        if (message?.color) {
            this._color = message?.color;
        } else {
            this._color = "success";
        }
        if (message.timeout) {
            this._timeout = message.timeout;
        } else {
            this._timeout = 3000;
        }
    }

    @Action
    resetState(): Promise<any> {
        this.context.commit('registerNewMessage', "");
        return Promise.resolve("");
    }

    get isShowMessage(): boolean {
        return this._show;
    }

    get getMessage(): string {
        return this._message;
    }

    get getColor(): string {
        return this._color;
    }
    get getTimeout(): number {
        return this._timeout;
    }
}

export default Notifications;
